import { render, staticRenderFns } from "./BaseCategoryPage.vue?vue&type=template&id=136c134d&"
import script from "./BaseCategoryPage.vue?vue&type=script&lang=js&"
export * from "./BaseCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports